/**
 * Helpers de SalesPRO para nomenclatura de archivos y compartir.
 * Formato: MSA_DDMMYY_Titulo.ext
 */

export function salesProFilename(title, ext = 'xlsx') {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yy = String(now.getFullYear()).slice(-2);
  const cleanTitle = (title || 'Reporte')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')  // sin tildes
    .replace(/[^a-zA-Z0-9_]+/g, '_')
    .replace(/^_|_$/g, '');
  return `MSA_${dd}${mm}${yy}_${cleanTitle}.${ext}`;
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
}

export function shareWhatsapp(text, url) {
  const msg = url ? `${text}\n\n${url}` : text;
  window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
}

export function shareEmail(subject, body) {
  window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
